export const GTM_PROJECT_CATEGORY = "Promotion";
export const BASE_URL = "https://www.airasia.com";


